export const TEMPLATE = {
  'Bizagi':
    {
      'userAdminMail': 'admin@domain.com',
      'unlockRequestNotificationSubject': 'You got a new unlock account request from <usernameAndDomain>',
      'unlockRequestNotificationBody': 'Hi,\r\n\r\nThere is a new unlock request in the system.\r\n\r\nDomain: <domain>\r\nUsername : <username>\r\nDate:\t<date> <time>\r\n\r\nObservation:<observation>\r\n\r\nthanks,\r\nBizagi administration',
      'sentPasswordNotificationSubject': 'Notification about account <usernameAndDomain> in Bizagi',
      'sentPasswordNotificationBody': 'Mr(s) <full Name>\r\n\r\nYour account has been activated. Please change your password the next time you enter Bizagi\r\n\r\nCreation Date: \t<date> <time>\r\nUsername: \t<username>\r\nDomain:\t\t<domain>\r\nPassword:\t<password>\r\n\r\nBizagi Administration',
      'passwordReminderNotificationSubject': 'Password reminder for user <usernameAndDomain>',
      'passwordReminderNotificationBody': 'Your password to enter Bizagi:\r\n\r\n<password>\r\n\r\nBizagi Administration\r\n<date> <time>'
    },
  'Custom': {
    'customAuthenticationClass': 'AUTHOPTIONS_DefaultValue_customAuthenticationClass'
  },
  'Ldap': {
      'path': 'AUTHOPTIONS_DefaultValue_path'
    },
  'Federated': {
    'trustedIssuersThumbprint': 'AUTHOPTIONS_DefaultValue_trustedIssuersThumbprint'
  }
};
